import { UserRole } from "./user-role";

export const AssignRoles = [
  UserRole.FarmTreeDeveloper,
  UserRole.FarmTreeMaster,
  UserRole.ProjectOwner,
];
